"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ANNUAL = exports.MONTHLY = void 0;
var MONTHLY = 'monthly';
exports.MONTHLY = MONTHLY;
var ANNUAL = 'annual';
exports.ANNUAL = ANNUAL;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/Terms.js
// module id = 42
// module chunks = 5 6 7